import {
  GET_BHARAT_STATES,
  GET_BHARAT_CONSTITUENCY,
  GET_BHARAT_MP,
  ERR_BHARAT_POLL,
} from "../actions/actionTypes";

const initialStatesState = {
  states: [],
  allowedRoles: [],
  errors: false,
};

const initialConstituencyState = {
  constituencies: [],
  allowedRoles: [],
  errors: false,
};

const initialConstituenciesMpState = {
  constituenciesMp: [],
  allowedRoles: [],
  errors: false,
};

// //!  States Reducer...
function statesReducer(state = initialStatesState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_BHARAT_STATES:
      return {
        ...state,
        states: payload,
        loading: false,
        errors: false,
      };
    case ERR_BHARAT_POLL:
      return {
        ...state,
        errors: true,
        loading: false,
      };
    default:
      return state;
  }
}

// //!  Constituencies Reducer...
function constituencyReducer(state = initialConstituencyState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_BHARAT_CONSTITUENCY:
      return {
        ...state,
        constituencies: payload,
        loading: false,
        errors: false,
      };
    case ERR_BHARAT_POLL:
      return {
        ...state,
        errors: true,
        loading: false,
      };
    default:
      return state;
  }
}

// //!  Constituencies Mp Reducer...
function constituenciesMpReducer(state = initialConstituenciesMpState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_BHARAT_MP:
      return {
        ...state,
        constituenciesMp: payload,
        loading: false,
        errors: false,
      };
    case ERR_BHARAT_POLL:
      return {
        ...state,
        errors: true,
        loading: false,
      };
    default:
      return state;
  }
}

export { statesReducer, constituencyReducer, constituenciesMpReducer };
